import { handleActions } from "redux-actions";

const eventReducer = handleActions(
  {
    EVENTS_GET_PENDING: () => ({
      events: [],
    }),
    EVENTS_GET_FULFILLED: (state, action) => ({
      events: action.payload.events,
    }),
  },
  {},
  { namespace: "_" }
);

export default eventReducer;
